import { de, enUS, fr, it, Locale } from "date-fns/locale"

const DATE_FNS_LOCALE_BY_LANGUAGE: Partial<Record<string, Locale>> = { en: enUS, de, fr, it }

const getDateFnsLocale = (language: string): Locale => DATE_FNS_LOCALE_BY_LANGUAGE[language] ?? enUS

export { getDateFnsLocale }
